<template>
  <div class="p-4" style="background-color: white;">
    <slot name="header"></slot>
    <vue-good-table max-height="60vh" :columns="columns" :rows="rows">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.label === 'Edit'">
          <div class="d-flex align-items-center justify-content-center">
            <div :class="{c__info: !ownsAudience(props.row)}">
              <div class="c__tooltip_container">
                <button
                  @click="handleEditClicked(props.row)"
                  :style="{opacity: ownsAudience(props.row) ? 1 : 0.25}"
                >
                  <div style="height: 20px; width: 20px;">
                    <img src="../../../assets/icons/pencil-icon.svg" />
                  </div>
                </button>
                <div class="c__tooltip" v-if="!ownsAudience(props.row)">
                  Only the creator of this audience can EDIT this audience
                </div>
              </div>
            </div>
          </div>
        </span>
        <span v-if="props.column.label === 'Delete'">
          <div class="d-flex align-items-center justify-content-center">
            <div :class="{c__info: !ownsAudience(props.row)}">
              <div class="c__tooltip_container">
                <button
                  @click="handleDeleteClicked(props.row)"
                  :style="{opacity: ownsAudience(props.row) ? 1 : 0.25}"
                >
                  <div style="height: 20px; width: 20px;">
                    <img src="../../../assets/icons/trash-icon.svg" />
                  </div>
                </button>
                <div class="c__tooltip" v-if="!ownsAudience(props.row)">
                  Only the creator of this audience can DELETE this audience
                </div>
              </div>
            </div>
          </div>
        </span>

        <span v-else-if="props.column.label === 'Type'">
          <div class="d-flex">
            <span> {{ props.formattedRow[props.column.field] }}</span>
            <div
              class="c__info"
              v-if="
                props.formattedRow[props.column.field] !== 'Global' &&
                  props.formattedRow[props.column.field]
              "
            >
              <div
                @click="handleViewClicked(props.formattedRow)"
                style="height: 12px; width: 12px;"
                class="c__tooltip_container ml-2"
              >
                <img
                  src="../../../assets/icons/icon-search-blue.svg"
                  alt="View"
                />
                <span class="c__tooltip"
                  >View assigned
                  {{
                    props.formattedRow[props.column.field].toLowerCase()
                  }}s</span
                >
              </div>
            </div>
          </div>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
    <view-audience-availability-modal
      :visible="showModal"
      @close-modal="closeModal"
      :data="viewAudienceData"
      :scopeDisplay="scopeDisplay"
    ></view-audience-availability-modal>
  </div>
</template>

<script>
import {VueGoodTable} from 'vue-good-table';
import ViewAudienceAvailabilityModal from './ViewAudienceAvailabilityModal.vue';
import UtcToTimezone from '../../../helpers/UtcToTimezone';
import {format} from 'date-fns';

export default {
  props: ['data'],
  data() {
    return {
      showModal: false,
      viewAudienceData: [],
      scopeDisplay: null,
    };
  },
  components: {
    VueGoodTable,
    ViewAudienceAvailabilityModal
  },
  methods: {
    handleDeleteClicked(audience) {
      if (this.ownsAudience(audience)) {
        this.$emit('on-delete-clicked', audience);
      }
    },
    handleEditClicked(audience) {
      if (this.ownsAudience(audience)) {
        this.$emit('on-edit-clicked', audience);
      }
    },
    handleViewClicked(audience) {
      this.viewAudienceData = audience.assignments;
      this.scopeDisplay = audience.scopeDisplay;
      this.showModal = true;
    },
    ownsAudience(audience) {
      const user = this.$store.getters.getUser;

      return audience.createdBy.id === user.id;
    },
    closeModal() {
      this.showModal = false;
    },
  },
  computed: {
    columns() {
      return [
        {
          label: 'ID',
          field: 'id',
          hidden: true,
        },
        {
          label: 'Assignments',
          field: 'assignments',
          hidden: true,
        },
        {
          label: 'Audience Name',
          field: 'name',
        },
        {
          label: 'Type',
          field: 'scopeDisplay',
        },
        {
          label: 'Created By',
          field: (props) =>
            `${props.createdBy.firstName} ${props.createdBy.lastName}`,
        },
        {
          label: 'Created At',
          field: (props) =>
            format(UtcToTimezone(props.createdAt, 'yyyy-MM-dd HH:mm:ss'), 'DD MMM YYYY h:mm A'),
          type: 'text',
        },
        {
          label: 'Edited At',
          field: (props) =>
            format(UtcToTimezone(props.updatedAt, 'yyyy-MM-dd HH:mm:ss'), 'DD MMM YYYY h:mm A'),
          type: 'text',
        },
        {
          label: 'Edit',
          field: '---',
        },
        {
          label: 'Delete',
          field: '---',
        },
      ];
    },
    rows() {
      if (!this.data) return [];

      return this.data.getRows();
    },
  },
};
</script>
